(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/media-queries/mobile.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/media-queries/mobile.js');

'use strict';

const loginMethods = svs.iam_idp.constants.loginMethods;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const activeMethodAtom = svs.iam_idp.atoms.activeMethodAtom;
const BankIdMain = svs.iam_idp.components.bank_id.BankIdMain;
const FrejaMain = svs.iam_idp.components.freja.FrejaMain;
const Mobile = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return activeMethod === loginMethods.bankid ? React.createElement(BankIdMain, {
    showQR: false
  }) : React.createElement(FrejaMain, {
    showQR: false
  });
};
svs.iam_idp.components.media_queries.Mobile = Mobile;

 })(window);